// extracted by mini-css-extract-plugin
export default {"cakeCard":"Cake_cakeCard__c274k"};